import { BaseField } from './BaseField';

const TextAreaField = ({ ...props }) => (
  <BaseField {...props}>{inputProps => <textarea {...inputProps} />}</BaseField>
);

export default TextAreaField;
